export default "__VITE_ASSET__gIOhXam6__"